<div>
  <div [formGroup]="form">
    @for (element of formElements; track element) {
      <form-base-element [formElement]="element" [form]="form" [model]="model" />
    }
  </div>
</div>
